module.exports = __webpack_public_path__ + "static/media/ic-date.e80db541.svg";